import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, startWith, switchMap, tap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Formule } from '../formules.interface';
import { AnnulationAcompteData, InfoAcompteEnCours } from '../../global/acompte-annulation.interface';

@Injectable({
  providedIn: 'root',
})
export class AcompteAnnulationService {
  private httpClient = inject(HttpClient);
  /* Relu a chaque ouverture, meme sur le meme element (`equal: () => false`) ; les infos sont
     vides (`startWith(undefined)`) tant que la reponse n'est pas arrivee. */
  private formule = signal<Formule | undefined>(undefined, { equal: () => false });

  acompteAAnnuler = signal<AnnulationAcompteData | undefined>(undefined);
  acompteAnnule = signal<boolean>(false);

  private creationAcompte = toSignal(
    toObservable(this.acompteAAnnuler).pipe(
      filter(a => !!a),
      switchMap(a =>
        this.httpClient.post<InfoAcompteEnCours>(`${environment.backendUrl}redditions/acompte/${a.idAcompte}/annuler`, {
          commentaire: a.commentaire,
        }),
      ),
      tap(() => this.acompteAnnule.set(true)),
    ),
  );

  setFormule(formule: Formule) {
    this.formule.set(formule);
  }

  infosAcompteEnCours = toSignal(
    toObservable(this.formule).pipe(
      filter(formule => !!formule),
      switchMap(formule =>
        this.httpClient
          .get<InfoAcompteEnCours>(`${environment.backendUrl}redditions/formules/${formule!.id}/acompte-en-cours`)
          .pipe(startWith(undefined)),
      ),
    ),
  );
}
